import { ContactEffects } from './contact/contacts.effects';
import { RecipientEffects } from './recipient/recipient.effects';

export const chatEffects = [ContactEffects, RecipientEffects];
